import { LazyFallback } from 'components/shared/LazyFallback';
import { Suspense } from 'react';
import { lazyWithRetry } from 'shared/lazy';

const SecondaryOrdersBlotterRouteLazy = lazyWithRetry(() => import('./SecondaryOrdersBlotter'));

export function SecondaryOrdersBlotterRoute() {
  return (
    <Suspense fallback={<LazyFallback />}>
      <SecondaryOrdersBlotterRouteLazy />
    </Suspense>
  );
}
